<template>
  <v-app id="appContainer" :style="cssProps">
    <!-- Header -->
    <!-- <div class="pr-2 ml-1" style="z-index: 200; align: center; width: 100%" > -->
    <!-- </div> -->
    <v-alert
      id="alert"
      ref="alertBanner"
      transition="scale-transition"
      outlined
      :class="{ 'pt-0': !$vuetify.breakpoint.mdAndUp }"
      class="mb-0 alertBanner"
      v-model="pausedBanner"
      type="warning"
      color="primary"
      width="100%"
      :prominent="$vuetify.breakpoint.mdAndUp"
      border="left"
      dense
      dismissible
      height="70"
      style="
        background-color: white !important;
        position: sticky;
        top: 64px;
        z-index: 201;
      "
    >
      <!-- <small v-if="$vuetify.breakpoint.smAndDown">Nettbutikken er midlertidig ute av drift. Du kan se på produktene, men det er ikke mulig å bestille varer!</small> -->
      <span
        :style="
          $vuetify.breakpoint.mdAndUp
            ? ''
            : 'font-size: 12px; line-height: 0.75rem'
        "
        :class="$vuetify.breakpoint.mdAndUp ? '' : 'text-sm-12'"
        >Nettbutikken er midlertidig ute av drift. Du kan se på produktene, men
        det er ikke mulig å bestille varer!</span
      >
    </v-alert>

    <the-fixit-no-header
      :useOldNavigation="false"
      @setUser="setActiveUser"
      @notify="setNotification"
      @loginWithJwt="loginWithJwt"
      v-if="webshopSettings"
      :support-membership="true"
      :header-props="header"
      :active-user="user"
      :use-axios="true"
      :new-release="
        (mainMenuHasPromotionItem() && !headerNavigationHasPromotionItem()) ||
        (mainMenuHasPromotionItem() && $vuetify.breakpoint.smAndDown)
      "
      ref="fixitNoHeader"
    >
      <template v-slot:logo>
        <img
          @click="homeRedirect()"
          class="header-logo"
          :src="webshopSettings.chainLogoUrl"
          :alt="$umbraco.images.logo.Alt"
          height="80%"
          style="object-fit: contain"
          loading="eager"
        />
      </template>

      <template v-slot:shopping-cart>
        <click-and-collect-cart
          v-if="$vuetify.breakpoint.mdAndUp"
          :init-data-fetched="initDataFetched"
          :header-props="header"
          class="webshop__cart"
        ></click-and-collect-cart>
      </template>
    </the-fixit-no-header>
    <!-- Main content -->
    <v-main v-if="!initLoading" :style="{ 'min-height': `100vh` }">
      <webshop-search
        v-if="search"
        @search-event="searchEvent"
        @overlay-event="overlayEvent"
      ></webshop-search>
      <webshop-categories
        v-if="!$route.name.includes('mypage')"
        @overlay-event="overlayEvent"
        @search-event="searchEvent"
        :style="{
          top: $vuetify.breakpoint.mdAndUp
            ? pausedBanner
              ? '134px'
              : '64px'
            : pausedBanner
            ? '64px'
            : '0',
        }"
      ></webshop-categories>
      <div class="d-flex" style="height: 100%">
        <webshop-filter
          v-if="filterVisible && $vuetify.breakpoint.mdAndUp"
          :background-color="'transparent'"
        ></webshop-filter>
        <!--                <div v-if="breadcrumbs.length > 1"-->
        <!--                     :style="{left: $vuetify.breakpoint.mdAndUp ? '330px' : 0}"-->
        <!--                     class="breadcrumbs__container pa-4">-->
        <!--                    &lt;!&ndash; Breadcrumbs &ndash;&gt;-->
        <!--                    <v-breadcrumbs :items="breadcrumbs" class="d-inline-flex primary secondary&#45;&#45;text" large dark>-->
        <!--                        <template v-slot:divider>-->
        <!--                            <span class="secondary&#45;&#45;text">/</span>-->
        <!--                        </template>-->
        <!--                    </v-breadcrumbs>-->
        <!--                </div>-->
        <router-view />
      </div>
      <v-bottom-navigation
        v-if="$vuetify.breakpoint.smAndDown"
        v-model="selectedMobileMenuNavigation"
        color="primary"
        fixed
        grow
        style="bottom: 0"
      >
        <v-btn
          v-for="(nav, i) in mobileMenuNavigation.filter((nav) => nav.Visible)"
          :key="i"
          :class="
            $route.name != 'webshopChainShoppingCartClickAndCollect' &&
            $route.path.includes('nettbutikk') &&
            nav.Caption == 'Nettbutikk'
              ? 'mobile-navigation__btn-active ' + nav.Class || ''
              : nav.Class || ''
          "
          class="mobile-navigation__btn"
          min-width="60"
          small
          tag="a"
          @click="navigationAction(nav)"
        >
          <span>{{
            nav.MyProfile
              ? $user.onlineSluttKundeId
                ? "Min side"
                : "Logg inn"
              : nav.Caption
          }}</span>
          <v-icon>{{ nav.Icon }}</v-icon>
        </v-btn>
        <click-and-collect-cart
          :header-props="header"
          :init-data-fetched="initDataFetched"
          :is-mobile="true"
        />
        <div class="toolbar__menu-dialog"></div>
      </v-bottom-navigation>
    </v-main>

    <v-overlay :value="overlay" absolute z-index="202" />

    <v-overlay :value="initLoading" absolute z-index="999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <!-- Footer -->
    <v-footer
      v-if="!initLoading"
      class="footer secondary--text pt-8"
      color="primary"
      height="auto"
    >
      <v-container class="footer-container">
        <v-row>
          <v-col class="footer-navigation-col" cols="12" md="3" sm="6">
            <h3>Meny</h3>
            <nav aria-label="Footer">
              <ul class="menu-navigation">
                <li
                  v-for="(navigation, index) in chainMainNavigation"
                  :key="index"
                  class="mb-0"
                >
                  <a
                    v-if="navigation.Visible"
                    :class="navigation.Class || ''"
                    class=""
                    @click="navigationAction(navigation)"
                    >{{ navigation.Caption }}</a
                  >
                </li>
              </ul>
            </nav>
          </v-col>

          <v-col class="footer-navigation-col" cols="12" md="3" sm="6">
            <h3>Personvern</h3>
            <nav aria-label="Footer">
              <ul class="menu-navigation">
                <li
                  v-for="(navigation, index) in chainMainNavigationLegal"
                  :key="index"
                  class="mb-0"
                >
                  <a
                    :href="navigation.Link"
                    :target="navigation.OpenInNewWindow ? '_blank' : '_self'"
                    class="secondary--text"
                    rel="noopener"
                  >
                    {{ navigation.Caption }}
                  </a>
                </li>
              </ul>
            </nav>
          </v-col>

          <v-col class="footer-navigation-col" cols="12" md="3" sm="6">
            <h3>Tjenesten er levert av</h3>
            <a class="text-left" href="/bedrift">
              <v-lazy>
                <img
                  alt="Fixit Logo"
                  :src="fixitLogoSvgUrl"
                  class="mb-12 svg-secondary-fill"
                  width="100"
                />
              </v-lazy>
            </a>
          </v-col>
        </v-row>
      </v-container>
    </v-footer>

    <webshop-salon-pick-dialog
      :dialog="salonPickOptions.dialog"
      :selected-salon-id="selectedSalon ? selectedSalon.siteId : 0"
    ></webshop-salon-pick-dialog>
    <webshop-bundle-salon-pick-dialog
      :dialog="bundleSalonPickOptions.dialog"
      :selected-salon-id="selectedSalon ? selectedSalon.siteId : 0"
    ></webshop-bundle-salon-pick-dialog>
    <webshop-products-salon-pick-dialog
      :dialog="productsSalonPickOptions.dialog"
      :selected-salon-id="selectedSalon ? selectedSalon.siteId : 0"
    ></webshop-products-salon-pick-dialog>
    <product-added-to-cart-dialog
      :dialog="$store.getters['webshop/get']('addedToCartDialog')"
    ></product-added-to-cart-dialog>
    <product-added-to-cart-dialog
      :dialog="$store.getters['webshop/get']('addedProductsToCartDialog')"
    ></product-added-to-cart-dialog>
    <confirm-prompt-dialog
      ref="clear-cart-prompt-dialog"
      :dialog="clearCartPromptDialog"
      :text="`<div>Vil du tømme handlekurven?</div>`"
      cancel-button="Nei"
      confirm-button="Ja"
      persistent
      title="Tøm handlekurv"
      @action="clearCartPromptResponse"
    ></confirm-prompt-dialog>

    <!-- Alerts -->
    <v-snackbar
      v-model="snackbar.display"
      :bottom="snackbar.bottom == 'bottom'"
      :timeout="snackbar.timeout"
      :top="snackbar.top == 'top'"
      class="snackbar"
      color="base"
    >
      <v-icon
        v-if="['success', 'info', 'warning', 'error'].includes(snackbar.type)"
        :color="snackbar.type"
        left
      >
        {{ snackbar.type == "success" ? "check_circle" : snackbar.type }}
      </v-icon>
      {{ snackbar.text }}
      <v-btn v-if="snackbar.closeButton" text @click="snackbar.display = false"
        >Lukk</v-btn
      >
    </v-snackbar>
    <no-activated-salons-dialog
      v-if="!initLoading"
      :dialog="noActivatedSalonsDialog"
    ></no-activated-salons-dialog>
    <the-fixit-notification :snackbar="notification" />
  </v-app>
</template>

<script>
import ClickAndCollectCart from "@/components/webshop/cart/ClickAndCollectCart";
import WebshopCategories from "../views/webshop/components/WebshopCategories";
// import LoginDialog from '@/components/LoginDialog';
import WebshopSalonPickDialog from "@/components/webshop/WebshopSalonPickDialog";
import WebshopProductsSalonPickDialog from "@/components/webshop/WebshopProductsSalonPickDialog";
import WebshopBundleSalonPickDialog from "@/components/webshop/WebshopBundleSalonPickDialog";
import ProductAddedToCartDialog from "@/components/webshop/ProductAddedToCartDialog";
import ConfirmPromptDialog from "@/components/common/ConfirmPromptDialog.vue";
import { getBreadcrumbs } from "@/router/helpers";
import { Snackbar } from "@/services/models";
import webshopMixins from "@/components/webshop/cart/webshop.mixins.js";
import { mapWaitingActions } from "vue-wait";
import WebshopFilter from "../components/webshop/WebshopFilter";
import WebshopSearch from "@/components/webshop/WebshopSearch.vue";
import NoActivatedSalonsDialog from "@/components/webshop/NoActivatedSalonsDialog";
import { waitFor } from "vue-wait";
import { createPrimaryOpacityVariables } from "../utils/opacity-colors";
import { User, Header, Notification } from "@fixit/fixit-no-header/src/models";
import TheFixitNotification from "@/components/TheFixitNotification.vue";
import {
  TheFixitNoHeader,
  // TheFixitNoSnackbar
} from "@fixit/fixit-no-header";

export default {
  name: "App",
  components: {
    WebshopSearch,
    WebshopFilter,
    WebshopCategories,
    // LoginDialog,
    ClickAndCollectCart,
    WebshopSalonPickDialog,
    ConfirmPromptDialog,
    ProductAddedToCartDialog,
    NoActivatedSalonsDialog,
    WebshopBundleSalonPickDialog,
    WebshopProductsSalonPickDialog,
    TheFixitNoHeader,
    // TheFixitNoSnackbar,
    TheFixitNotification,
  },
  data() {
    return {
      activeTab: 0,
      selectedMobileMenuNavigation: null,
      initDataFetched: false,
      overlay: false,
      atTop: true,
      menuDialogOpen: false,
      loginDialogOpen: false,
      overrideLoginOptions: null,
      snackbar: {
        display: false,
      },
      showBadge: false,
      noActivatedSalonsDialog: false,
      fixitLogoSvgUrl: require("@/assets/img/fixit-logo-black.svg"),
      cmsTheme: null,
      search: false,
      snackbarState: new Notification(),
      authRoutes: [
        "mypage",
        // "webshopChainShoppingCartClickAndCollect",
        "webshopChainCheckoutClickAndCollectOrderPreview",
        "webshopChainCheckoutCompletedClickAndCollect",
      ],
      // webshopPaused: false
    };
  },
  mixins: [webshopMixins],
  computed: {
    header() {
      return new Header({
        header: 64,
        elevation: 1,
        fixitNoUrl: process.env.VUE_APP_FIXIT_NO_URL,
        oauthUrl: process.env.VUE_APP_OAUTH_URL,
        apiUrl: process.env.VUE_APP_FIXIT_CORE_API_URL,
        items: this.chainMainNavigation,
        layout: "chain",
        sites: this.webshopSettings.activatedSalons,
      });
    },
    notification: {
      get() {
        return this.snackbarState;
      },
      set(snack) {
        this.snackbarState = snack;
      },
    },
    chainMainNavigation() {
      return [
        {
          Caption: "Nettbutikk",
          Id: null,
          IsInternal: true,
          Action: "replace",
          Link:
            "/nettbutikk/" +
            (this.$route.params.chainId || this.$route.query.chainId),
          OpenInNewWindow: false,
          Type: 1,
          Visible: true,
        },
        {
          Caption: "Bestill time",
          Class: "fixit-booking",
          Id: null,
          IsInternal: false,
          OpenInNewWindow: false,
          Type: 2,
          Visible: this.webshopSettings?.hasBooking || false,
        },
        {
          Caption: "Kjøp gavekort",
          Id: null,
          IsInternal: false,
          Link:
            "/gavekort/" +
            (this.$route.params.chainId || this.$route.query.chainId),
          OpenInNewWindow: false,
          Type: 1,
          Visible: this.webshopSettings?.hasGiftcard || false,
        },
      ];
    },

    chainMainNavigationLegal() {
      return [
        {
          Caption: "Vilkår for bruk",
          Id: null,
          IsInternal: false,
          Link: "/bedrift",
          OpenInNewWindow: false,
          Type: 1,
        },
        {
          Caption: "Personvern",
          Id: null,
          IsInternal: false,
          Link:
            "/personvern/" +
            +(this.$route.params.chainId || this.$route.query.chainId),
          OpenInNewWindow: false,
          Type: 1,
        },
      ];
    },

    mobileMenuNavigation() {
      return [
        {
          Caption: "Bestill time",
          Icon: "event",
          Class: "fixit-booking",
          Id: null,
          IsInternal: false,
          OpenInNewWindow: false,
          Type: 1,
          Visible: this.webshopSettings?.hasBooking || false,
          BlockMobileNavigation: true,
        },
        {
          Caption: "Nettbutikk",
          Icon: "storefront",
          IsInternal: true,
          Action: "replace",
          Link:
            "/nettbutikk/" +
            (this.$route.params.chainId || this.$route.query.chainId),
          OpenInNewWindow: false,
          Type: 1,
          Visible: true,
        },
        {
          Caption: "Gavekort",
          Icon: "card_giftcard",
          Id: null,
          IsInternal: false,
          Link:
            "/gavekort/" +
            (this.$route.params.chainId || this.$route.query.chainId),
          OpenInNewWindow: false,
          Type: 1,
          Visible: this.webshopSettings?.hasGiftcard || false,
        },
        {
          Caption: this.$user.onlineSluttKundeId ? "Min side" : "Logg inn",
          MyProfile: true,
          Icon: "person",
          Dialog: true,
          DialogVariable: "loginDialogOpen",
          IsInternal: false,
          OpenInNewWindow: false,
          Type: 1,
          Visible: false,
        },
      ];
    },

    initLoading() {
      return (
        !this.initDataFetched ||
        this.$wait.is("loading webshop getWebshopSettings")
      );
    },

    homePageUrl() {
      return this.webshopSettings.chainHomePageUrl
        ? `${
            this.webshopSettings.chainHomePageUrl.substr(0, 4) == "http"
              ? ""
              : "//"
          }${this.webshopSettings.chainHomePageUrl}`
        : `/nettbutikk/${this.currentChainId}`;
    },

    cart() {
      return this.$store.getters["clickAndCollect/get"]("items");
    },
    activeCarts() {
      return this.$store.getters["clickAndCollect/get"]("carts");
    },
    breadcrumbs() {
      return getBreadcrumbs(this.$route.name);
    },

    currentChainId() {
      return parseInt(this.$route.params.chainId || this.$route.query.chainId);
    },

    currentSiteId() {
      return this.$route.params.siteId;
    },
    cssProps() {
      return {
        "--primary-light": this.cmsTheme
          ? this.cmsTheme.PrimaryColor50Light
          : "#917b92",
      };
    },
    user: {
      get() {
        return new User(this.$user);
      },
      set(user) {
        this.$user.assign(user);
      },
    },
  },
  methods: {
    ...mapWaitingActions("webshop", {
      getCategories: "loading webshop getCategories",
      getWebshopSettings: "loading webshop getWebshopSettings",
    }),

    ...mapWaitingActions("clickAndCollect", {
      fetchCart: "loading clickAndCollect fetchCart",
      clearCart: "loading clickAndCollect clearCart",
    }),
    ...mapWaitingActions("checkout", {
      getShoppingCart: "loading clickAndCollect fetchCarts",
      dropShoppingCart: "loading checkout drop",
    }),

    ...mapWaitingActions("favorites", {
      getFavoriteProducts: "loading favorites getFavoriteProducts",
      getFavoriteTreatments: "loading favorites getFavoriteTreatments",
      $reset: "loading favorites reset"
    }),


    navigationAction(nav) {
      if (nav.Dialog) this[nav.DialogVariable] = true;
      else if (nav.IsInternal) this.$router[nav.Action](nav.Link);
      else if (nav.Link) {
        window.open(nav.Link, nav.OpenInNewWindow ? "_blank" : "_self");
      }
    },

    setActiveUser(user) {
      if (this.user.onlineSluttKundeId > 0 && !(user.onlineSluttKundeId > 0)) {
        this.dropShoppingCart(this.webshopSettings?.activatedSalons[0].siteId);
        this.$reset();
      }
      if (user.onlineSluttKundeId > 0) {
        this.user = user;
        this.getFavoriteProducts()
        this.getFavoriteTreatments()
      } else {
        this.logOut();
      }
    },
    async logOut() {
      this.loading++;
      waitFor(`loading user logout`, async function () {
        if (await this.$store.dispatch("user/logout")) {
          this.$user.assign(new User());
          setTimeout(() => {
            this.$forceUpdate();
            this.$eventBus.$emit("user-logged-out");
          }, 250);
          this.$store.dispatch('user/getLastVisitedSalons');
          this.dialog = false;

          // To prevent error (NavigationDuplicated) "https://github.com/vuejs/vue-router/issues/2872"
          // We use replace instead of push.
          let chainId = this.$route.params.chainId || this.$route.query.chainId;
          if (this.authRoutes.includes(this.$route.name)) {
            this.$router
              .replace(
                chainId
                  ? { name: "webshopChain", params: { chainId } }
                  : { name: "frontpage" }
              )
              .catch(() => {});
          }
        }

        // Logout failed.
        else {
          this.$eventBus.$emit("notify", {
            message: "Utlogging feilet. Vennligst prøv på nytt.",
            state: "error",
            title: "Utlogging feilet",
            visible: true,
          });
        }
      }).apply(this);
      this.loading--;
    },

    overlayEvent(val) {
      this.overlay = val;
    },

    searchEvent(val) {
      let html = document.getElementsByTagName("HTML")[0];
      html.style.overflow = val ? "hidden" : "auto";
      this.search = val;
    },

    async clearCartPromptResponse(action) {
      if (action)
        await this.clearCart({
          onlineSluttKundeId: this.$user.onlineSluttKundeId,
          chainId: this.currentChainId,
        });
      this.$store.dispatch("clickAndCollect/set", {
        key: "clearCartPromptDialog",
        value: false,
      });
    },

    async navigate(path) {
      await this.$router
        .push(`/${path}?chainId=${this.currentChainId}`)
        .catch(() => {}); // add catch to handle NavigationDuplicated error exception in console
      this.menuDialogOpen = false;
      this.loginDialogOpen = false;
    },

    setSnackbar(snackbar = new Snackbar()) {
      this.snackbar = Object.assign({}, this.snackbar, {
        ...snackbar,
        display: true,
      });
    },

    setLoginDialogOpen(loginDialogOpen, overrideOptions) {
      // TODO: Add form data to prefill create profile
      this.loginDialogOpen = loginDialogOpen;
      this.overrideLoginOptions = overrideOptions;
      if (this.$refs.fixitNoHeader) this.$refs.fixitNoHeader.openDialog();
    },

    forceUpdate() {
      this.$forceUpdate();
    },

    headerNavigationHasPromotionItem() {
      const promoteMenuItemText =
        this.$umbraco.settings.promoteMenuItemContainingText;
      return (
        this.$umbraco.settings.promoteMainMenu &&
        this.$umbraco.navigation.b2CHeaderNavigation.filter(
          (x) => x.Caption.toLowerCase().indexOf(promoteMenuItemText) != -1
        ).length > 0
      );
    },

    mainMenuHasPromotionItem() {
      const promoteMenuItemText =
        this.$umbraco.settings.promoteMenuItemContainingText;
      return (
        this.$umbraco.settings.promoteMainMenu &&
        this.$umbraco.navigation.b2cMenuNavigation.filter(
          (x) => x.Caption.toLowerCase().indexOf(promoteMenuItemText) != -1
        ).length > 0
      );
    },

    showMenuItemPromotion(caption) {
      // TODO: Refactor into Umbraco helper
      const displayMenuBadge = this.$umbraco.settings.promoteMainMenu;
      const promoteMenuItemText =
        this.$umbraco.settings.promoteMenuItemContainingText;

      return (
        promoteMenuItemText &&
        caption.toLowerCase().indexOf(promoteMenuItemText) != -1 &&
        displayMenuBadge
      );
    },
    setNotification(snackbar) {
      if (snackbar.title == "Produkt kombinasjon ikke tilgjengelig") {
        this.$store.dispatch("webshop/set", {
          key: "addedToCartDialog",
          value: false,
        });
      }
      if (snackbar.message == "Du har logget ut!") {
        this.$eventBus.$emit("snackbar", {
          text: "Du har logget ut!",
          type: "info",
        });
      } else {
        this.notification = new Notification(snackbar);
      }
    },
    closeNotification(snackbar) {
      this.notification = new Notification(snackbar);
    },
    async loginWithJwt() {
      await this.$store.dispatch("user/LoginByJwt").then(async (res) => {
        if (res) this.$eventBus.$emit("user-logged-in", this.$user);
        this.$store.dispatch('user/getLastVisitedSalons');
        await this.getShoppingCart({
          chainId: this.$route.params.chainId || this.$route.query.chainId,
        });
      });
    },
    openLogin() {
      if (this.$refs.fixitNoHeader) this.$refs.fixitNoHeader.openDialog();
    },
    homeRedirect() {
      if (
        this.webshopSettings.chainHomePageUrl != null &&
        this.webshopSettings.chainHomePageUrl != undefined &&
        this.webshopSettings.chainHomePageUrl != ""
      ) {
        window.open(
          this.webshopSettings.chainHomePageUrl.includes("https") ||
            this.webshopSettings.chainHomePageUrl.includes("http")
            ? this.webshopSettings.chainHomePageUrl
            : "https://" + this.webshopSettings.chainHomePageUrl,
          "_self"
        );
      } else window.open(process.env.VUE_APP_FIXIT_NO_URL, "_self");
    },
  },
  watch: {
    selectedMobileMenuNavigation: {
      handler(v, oldVal) {
        if (!this.webshopSettings) return;
        let visibleMenuItems = this.mobileMenuNavigation.filter(
          (x) => x.Visible
        );
        let cartIndex =
          this.$route.name === "webshopChainCheckoutClickAndCollect"
            ? -1
            : visibleMenuItems.length;
        let myProfileIndex = this.$route.path.includes("minside")
          ? -1
          : this.mobileMenuNavigation
              .filter((x) => x.Visible)
              .findIndex((x) => x.MyProfile);
        let blockedNavigationIndexes = [cartIndex, myProfileIndex];
        visibleMenuItems.forEach((x, i) => {
          if (x.BlockMobileNavigation) blockedNavigationIndexes.push(i);
        });
        if (blockedNavigationIndexes.includes(v))
          this.$nextTick(() => (this.selectedMobileMenuNavigation = oldVal));
      },
    },

    $route: {
      handler(v) {
        if (!this.webshopSettings) return;
        if (v.name === "webshopChainCheckoutClickAndCollect")
          this.selectedMobileMenuNavigation = this.mobileMenuNavigation.filter(
            (x) => x.Visible
          ).length;
        else if (v.path.includes("nettbutikk"))
          this.selectedMobileMenuNavigation = this.mobileMenuNavigation
            .filter((x) => x.Visible)
            .findIndex((x) => x.Caption === "Nettbutikk");
        else if (this.$route.path.includes("minside"))
          this.selectedMobileMenuNavigation = this.mobileMenuNavigation
            .filter((x) => x.Visible)
            .findIndex((x) => x.MyProfile);
      },
    },

    "$vuetify.breakpoint.name"() {
      this.$nextTick(() => {
        if (document.getElementById("tpn-widget"))
          document.getElementById("tpn-widget").remove();
        let recaptchaScript = document.createElement("script");
        recaptchaScript.setAttribute(
          "src",
          "/TpnWidget/" + this.currentChainId
        );
        recaptchaScript.setAttribute("id", "tpn-widget");
        document.head.appendChild(recaptchaScript);
      });
    },

    activeTab(v) {
      // refactor, disable selecting Bestill time as active tab
      if (
        this.chainMainNavigation.find(
          (x) => x.Visible && x.Caption === "Bestill time"
        )
      )
        this.$nextTick(() => {
          this.activeTab = this.chainMainNavigation
            .filter((x) => x.Visible)
            .findIndex((x) => x.Caption === "Nettbutikk");
        });
    },

    cart: {
      handler(cartItems, oldCartItems) {
        if (this.currentChainId) {
          // update local storage if anonymous cart
          this.getShoppingCart({
            chainId: this.$route.params.chainId || this.$route.query.chainId,
          });
        }
      },
      deep: true,
    },
    loginDialogOpen(value) {
      // Reset forms when dialog is closed.
      if (!value) {
        this.overrideLoginOptions = null;
      }
    },
    menuDialogOpen(value) {
      this.showBadge = !value;
    },
  },
  async mounted() {
    var primary = getComputedStyle(document.documentElement).getPropertyValue(
      "--v-primary-base"
    );
    createPrimaryOpacityVariables(primary);
    // enable browser back button when coming directly to the webshop so that router beforeEach can be triggered
    this.$router.push({
      query: {
        ...this.$route.query,
        load: this.$route.query.load == "1" ? "0" : "1",
      },
    });

    this.$eventBus.$on("snackbar", this.setSnackbar);
    this.$eventBus.$on("notify", (snackbar) => this.setNotification(snackbar));
    this.$eventBus.$on("force-update", this.forceUpdate);
    this.$eventBus.$on("login-dialog", this.setLoginDialogOpen);
    // Set chain theme
    if (
      window.CONFIG &&
      window.CONFIG.cmsTheme &&
      window.CONFIG.cmsTheme.PrimaryColor
    ) {
      const cmsTheme = window.CONFIG.cmsTheme;
      this.cmsTheme = cmsTheme;
      let theme = {
        dark: {
          base: "#FFFFFF",
          primary: cmsTheme.PrimaryColor,
          secondary: cmsTheme.SecondaryColor, //,cmsTheme.SecondaryColor,
        },
        light: {
          base: "#000000",
          primary: cmsTheme.PrimaryColor,
          secondary: cmsTheme.SecondaryColor, //,cmsTheme.SecondaryColor,
        },
      };
      const name = "ChainCustomTheme";
      const dark = theme.dark;
      const light = theme.light;

      // set themes
      Object.keys(dark).forEach((i) => {
        this.$vuetify.theme.themes.dark[i] = dark[i];
      });
      Object.keys(light).forEach((i) => {
        this.$vuetify.theme.themes.light[i] = light[i];
      });

      this.$vuetify.theme.dark = cmsTheme.IsDarkTheme;
      // also save theme name to disable selection
      this.$vuetify.theme.themes.name = name;

      await this.$store.dispatch(
        "site/GetSiteIdsByChainId",
        this.$route.params.chainId
      );
    }

    await this.getCategories({ params: { chainId: this.currentChainId } });
    await this.getWebshopSettings({
      params: { chainId: this.currentChainId, siteId: 0 },
    });
    let home = this.webshopSettings.chainHomePageUrl || `/`;
    if (
      !this.webshopSettings.active &&
      !this.webshopSettings.activatedSalons.length
    ) {
      if (home == "/") {
        this.$router.replace(this.homePageUrl);
      } else {
        window.location.href = home;
      }
    } else if (
      !this.webshopSettings.active &&
      this.webshopSettings.activatedSalons.length
    ) {
      this.pausedBanner = true;
    } else if (
      this.webshopSettings.active &&
      !this.webshopSettings.activatedSalons.length
    ) {
      if (home == "/") {
        this.$router.replace(this.homePageUrl);
      } else {
        window.location.href = home;
      }
    }
    if (this.$route.name === "webshopChainCheckoutClickAndCollect")
      this.selectedMobileMenuNavigation = this.mobileMenuNavigation.filter(
        (x) => x.Visible
      ).length;
    else if (this.$route.path.includes("nettbutikk"))
      this.selectedMobileMenuNavigation = this.mobileMenuNavigation
        .filter((x) => x.Visible)
        .findIndex((x) => x.Caption === "Nettbutikk");
    else if (this.$route.path.includes("minside"))
      this.selectedMobileMenuNavigation = this.mobileMenuNavigation
        .filter((x) => x.Visible)
        .findIndex((x) => x.MyProfile);

    await this.getShoppingCart({
      chainId: this.$route.params.chainId || this.$route.query.chainId,
    });

    setTimeout(() => {
      this.showBadge = true;
    }, 1000);

    this.initDataFetched = true;
    this.$nextTick(() => {
      if (document.getElementById("tpn-widget"))
        document.getElementById("tpn-widget").remove();
      let recaptchaScript = document.createElement("script");
      recaptchaScript.setAttribute("src", "/TpnWidget/" + this.currentChainId);
      recaptchaScript.setAttribute("id", "tpn-widget");
      document.head.appendChild(recaptchaScript);
    });
    // correct init tab slider position - vuetify bug
    this.$nextTick(
      () =>
        (this.activeTab = this.chainMainNavigation
          .filter((x) => x.Visible)
          .findIndex((x) => x.Caption === "Nettbutikk"))
    );
  },
};
</script>

<style lang="scss">
@import "~@/styles/variables";

.v-application.webshop-layout {
  background-image: unset !important;

  .v-application--wrap {
    & > header {
      z-index: 200;

      .toolbar {
        transition: background-color 250ms, height 250ms;
        padding: 0 var(--container-padding);

        &.primary {
          color: var(--secondary) !important;
        }

        @media #{map-get($display-breakpoints, 'xs-only')} {
          padding: 0;
        }

        .v-toolbar__content {
          transition: height 250ms;
          margin: 0 auto;
          padding: 0;
        }

        .v-toolbar__content {
          max-width: unset !important;
        }

        .v-icon {
          font-size: 30px;
        }

        .v-btn:not(.btn__cart) {
          font-size: 20px;
          padding: 0 1rem !important;

          @media #{map-get($display-breakpoints, 'xs-only')} {
            padding: 0 !important;
          }
        }

        &__items {
          overflow: hidden;

          .toolbar__divider {
            @media #{map-get($display-breakpoints, 'xs-only')} {
              width: 2px;
              margin: 0;
            }
          }
        }

        &__divider {
          flex: 1 1 4px;
          display: inline-flex;
          align-self: center;
          width: 4px !important;
          max-height: unset;
          height: 48px;
          margin: 0 16px;
        }

        &__menu-dialog {
          .v-dialog--fullscreen {
            height: 100vh;
          }
        }
      }

      .v-tabs {
        .v-tab {
          letter-spacing: unset !important;
          font-weight: bold !important;
          font-size: 20px;
          text-transform: capitalize !important;
        }

        .v-tab:not(.v-tab--active) {
          color: inherit !important;
        }
      }

      a {
        text-decoration: none;
      }
    }

    & > .snackbar {
      .v-snack__content {
        justify-content: unset;
      }
    }

    & > .hide__tab__slider::v-deep {
      .v-tabs-slider-wrapper {
        display: none;
      }
    }

    h1 {
      font-family: "niveau-grotesk", sans-serif;
    }

    .v-bottom-navigation {
      .v-btn {
        &::before,
        &--active {
          background-color: white;
        }
      }

      .mobile-navigation__btn {
        background-color: white;

        &-active {
          background-color: var(--v-primary-lighten4);
        }
      }
    }
  }
}

/* Scrollbar */
/* width */
::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #fff;
}

::-webkit-scrollbar-track-piece {
  background: rgba(66, 190, 180, 0.1);
}

/* Handle */
::-webkit-scrollbar-thumb {
  // background: #978298;
  background: var(--v-primary-lighten1);
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  // background: #7e697f;
  background: var(--v-primary-lighten2) !important;
  transform: scale(1.1);
  cursor: pointer;
}

// .v-btn--rounded {
// 	border-radius: 4px !important;
// }

.v-btn--filter-action {
  position: fixed;
  bottom: 0;
  margin: 16px;
}

.hover-zoom {
  -webkit-transition: -moz-transform 0.2s ease-out;
  -moz-transition: -webkit-transform 0.2s ease-out;
  -o-transition: -o-transform 0.2s ease-out;
  transition: transform 0.2s ease-out;
  box-shadow: 6px 6px 6px 0 #e9e9e9, -6px 0px 10px 0 #e9e9e9;
}

.hover-zoom:hover {
  -moz-transform: scale(1.005);
  -webkit-transform: scale(1.005);
  -o-transform: scale(1.005);
  transform: scale(1.005);
  box-shadow: 10px 10px 10px 0 #e9e9e9, -10px 0px 12px 0 #e9e9e9;

  .buy-btn {
    display: block;
  }
}

.header-logo {
  &:hover {
    cursor: pointer;
  }
}

.menu-navigation {
  list-style-type: none;
  padding-left: 0 !important;
}

.primary-light--text {
  color: black !important;
}

.primary-light {
  background-color: var(--primary-light) !important;
  color: black !important;

  // a {
  //    color: #000000;
  // }
}

.v-alert--outlined .v-alert__icon {
  align-self: center !important;
}

//  .primary.lighten-20 {
//      //background: lighten(var(--v-primary-base), 20%);
//  }
</style>
